import Embed from '../../../components/Embed/Embed'

export default function Media (props = {
    oembed: null,
    img: {
        src: null,
        alt: null,
        height: null,
        width: null
    }
}) {
    if (!props.oembed
            && (!props.img || !props.img.src))
        return null

    return (
        <div className="media pad-section theme-dark">
            <div className="container">
                <Embed {...props} />
                {!props.oembed
                    && props.img
                    && props.img.src
                    && (
                        <img
                            src={props.img.src}
                            alt={props.img.alt || ''}
                            width={props.img.width}
                            height={props.img.height}
                        />)}
            </div>
        </div>
    )
}
